import { useContext, useEffect, useRef } from 'react'
import styled from 'styled-components'

import ContainerAbsolute from '../basic-components/ContainerAbsolute'
import { Header } from '../basic-components/HeaderFooter'
import HeaderTitle from '../basic-components/HeaderTitle'

import MapContext from '../context/MapContext'

const DEFAULTS = {
  backgroundColor: 'white',
  flex: '1'
}

const MapContainer = styled(ContainerAbsolute)`
display: flex;
flex-direction: column;
flex: 1;
`
const MapDiv = styled.div`
  position: relative;
  overflow: hidden;
  flex: ${props => props.flex ? props.flex : DEFAULTS.flex};
  /*height: 100%;*/
  border: 2px solid lightgrey;
  /*margin: 2px;*/
  background-color: ${props => props.backgroundColor ? props.backgroundColor : DEFAULTS.backgroundColor};
`

export default function Map({ onQueryClick }) {
  const mapRef = useRef();
  const { olMap } = useContext(MapContext);

  useEffect(() => {
    const mapclickHandler = (e) => {
      const resolution = olMap.getView().getResolution();
      onQueryClick(e.coordinate, resolution);
    }

    //console.error('** Map - useEffect ********************');
    if(olMap) {
      //console.log('setting olMap in Map.useEffect ********************');
      olMap.setTarget(mapRef.current);
      olMap.on('singleclick', mapclickHandler)
      return () => {
        //console.warn('** Map - useEffect CLEANUP **');
        olMap.un('singleclick', mapclickHandler);
        olMap.setTarget(undefined);
      }
    }
  },[olMap, onQueryClick]);

  // NOTE: Header is to push map top down so OpenLayers controls show
  return (
    <MapContainer>
      <Header>
        <HeaderTitle>dummy title</HeaderTitle>
      </Header>
      <MapDiv ref={mapRef} className="ol-map"/>
    </MapContainer>
  )
}
